import React from 'react';
import SidebarItem from './SidebarItem';
import * as Icons from 'lucide-react';

const Sidebar = ({ items = [], currentPath, collapsed = false, onToggle, role }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const from = urlParams.get('from');
  const toggleIcon = collapsed ? Icons.ChevronRight : Icons.ChevronLeft;

  return (
    <aside
      className={`transition-all duration-100 ${
        collapsed ? 'w-16' : 'w-72'
      } bg-blueDark text-white h-full flex flex-col relative`}
    >
      {/* Botão central para recolher/expandir */}
      <button
        onClick={onToggle}
        className="absolute top-1/2 right-0 transform -translate-y-1/2 w-6 h-20 bg-blueDarker rounded-l-lg flex items-center justify-center z-10"
        title={collapsed ? 'Expandir' : 'Recolher'}
      >
        {React.createElement(toggleIcon, { size: 18, strokeWidth: 2, className: 'text-white' })}
      </button>

      {/* Cabeçalho */}
      {!collapsed && (
        <div className="flex items-center justify-center w-full px-4 py-5 text-base uppercase tracking-wide bg-blueDarker font-jost">
          ACESSO DE {role === 'planner' ? 'PLANEJADOR' : 'ANALISTA'}
        </div>
      )}

      {/* Itens */}
      <div className="flex-1 flex flex-col justify-between">
        <nav className="flex flex-col gap-1">
          {items.map((item, index) => {
            if (!item.visible) return null;
            const Icon = Icons[item.icon] || (() => null);
            return (
              <SidebarItem
                key={index}
                icon={Icon}
                label={collapsed ? '' : item.label}
                href={item.href}
                active={currentPath === item.href || item.featureKey === from}
                collapsed={collapsed}
              />
            );
          })}
        </nav>

        {/* Botão de sair */}
        <form method="POST" action="/admins/sign_out">
          <input type="hidden" name="_method" value="delete" />
          <button
            type="submit"
            className={`flex items-center w-full px-4 py-5 text-base font-normal text-white hover:text-red-400 transition-colors duration-200 ${
              collapsed ? 'justify-center' : ''
            }`}
          >
            <Icons.LogOut className="w-5 h-5 mr-2 shrink-0" strokeWidth={1.25} />
            {!collapsed && 'Sair'}
          </button>
        </form>
      </div>
    </aside>
  );
};

export default Sidebar;
